import { Text } from '@cash-design-system/react'

type TextProps = React.ComponentProps<typeof Text>

type Props = TextProps & {
  bold?: boolean
}

export const Caption: React.FC<Props> = ({ children, bold = false, color, ...restOfProps }) => {
  return (
    <Text typography="helpText" color={color} {...restOfProps}>
      {children}
    </Text>
  )
}
